export const NOTES_MAX_CHARACTERS = 500;

export const COUNTER_SEPARATOR = '/';

export const TEST_ID = 'notesField';
